module.exports = __webpack_public_path__ + "img/logo-selbst-hilfe-schweiz.6ba6bb6a.svg";